import React from 'react';
import { Link } from 'react-router-dom';
//components
import { Icon } from '../../Components/Icons/Icons';
import { Text } from '../../UI/Text';
import { Button } from '../../UI/Button';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { Row, OuterMargin, HoverableLink } from '../../Layouts/index';

const Container = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 330px;
    padding: 20px;
`;

const LinkButton = styled(Link)`
    &:hover {
        opacity: 0.8;
    }

    transition: opacity ease-in 0.1s;
    border-radius: 5px;
`;

const AddButton = styled.button`
    width: 200px;
    height: 30px;
    border-radius: 100px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    outline: none;
    cursor: pointer;
    text-transform: uppercase;
    color: white;
`;

const LinkToAppDownload = ({ link }) => (
    <LinkButton target={'_blank'} to={link}>
        <Icon.Box size={'130x40'}>
            <Icon.AppStoreLogo />
        </Icon.Box>
    </LinkButton>
);

const AndroidAppDownload = ({ link }) => (
    <LinkButton target={'_blank'} to={link}>
        <Icon.Box size={'130x40'}>
            <Icon.GooglePlayLogo />
        </Icon.Box>
    </LinkButton>
);

AndroidAppDownload.defaultProps = {
    link: {
        pathname: 'https://play.google.com/store/apps/details?id=tona.workout.recording',
    },
};

LinkToAppDownload.defaultProps = {
    link: {
        pathname: 'https://itunes.apple.com/gb/app/tona-workout-recording/id1438739138?mt=8',
    },
};

const mapStateToProps = ({
    profile: {
        currentProfile: { id, fullName },
    },
}) => {
    return {
        id,
        fullName,
    };
};

const GymBannerType = props => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <div style={{ padding: '12px 25px' }}>
                <Text fontSize={12} center weight={100} opacity={'0.8'} lineHeight={'1.4'}>
                    To record a workout, download the app today and hit <strong>Record</strong>
                </Text>
            </div>
            <Row>
                <LinkToAppDownload />
                <AndroidAppDownload />
            </Row>

            {/* <div style={{ marginTop: '12px' }}>
                <Text small center weight={100} opacity={'0.8'}>
                    Android coming very soon!
                </Text>
            </div> */}
        </div>
    );
};

function BannerEmptyStatsLeaderboards({ userType }) {
    return (
        <Container>
            <div style={{ margin: '0 0 10px 0' }}>
                <Icon.Box size={'32x32'}>
                    <Icon.SadIcon />
                </Icon.Box>
            </div>
            <Text>No leaderboards saved to profile yet</Text>
            {handleLoginService.isAuthenticated() && <GymBannerType />}
        </Container>
    );
}

function BannerEmptyStatsActivity({ userType }) {
    return (
        <Container>
            <div style={{ margin: '0 0 10px 0' }}>
                <Icon.Box size={'32x32'}>
                    <Icon.SadIcon />
                </Icon.Box>
            </div>
            <Text>No workouts recorded yet</Text>
            {handleLoginService.isAuthenticated() && <GymBannerType />}
        </Container>
    );
}

const ClassesEmptyState = () => {
    return (
        <Container>
            <div style={{ margin: '0 0 10px 0' }}>
                <Icon.Box size={'32x32'}>
                    <Icon.SadIcon />
                </Icon.Box>
            </div>
            <Text>No classes created yet</Text>
        </Container>
    );
};

const MembersEmptyState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No members found</Text>
    </Container>
);

const MembershipTypesEmptyState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No membership types found</Text>
    </Container>
);

const FollowersEmptyState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>You have no followers yet</Text>
    </Container>
);

let CheckInClassEmptyState = ({ id, fullName: name }) => {
    return (
        <Container>
            <div style={{ margin: '0 0 10px 0' }}>
                <Icon.Box size={'32x32'}>
                    <Icon.SadIcon />
                </Icon.Box>
            </div>
            <Text weight={'bold'} fontSize={16}>
                No classes yet
            </Text>
            <Text alignCenter marginTop={'15px'} marginBottom={'15px'} weight={100} fontSize={13} opacity={0.85}>
                Add classes from your schedule to allow members to book from the app
            </Text>
            <Link to={`/gym-admin/calendar`} target={'_blank'}>
                <AddButton>Add classes</AddButton>
            </Link>
        </Container>
    );
};

const UsersEmptyState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No users found</Text>
    </Container>
);

const BookersEmptyState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No one has booked this class yet</Text>
    </Container>
);

const ClassNotSelectedState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0', color: 'white', fontSize: '32px' }}>
            <i className="fas fa-arrow-left" />
        </div>
        <Text fontSize={16} weight={'bold'}>
            Select a class to check in
        </Text>
    </Container>
);

const NoWorkoutsFoundState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No workouts found</Text>
    </Container>
);

const NoExercisesFoundState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No exercises found</Text>
    </Container>
);

const WorkoutPlanEmptyState = ({ toggleAdvancedSettings }) => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box opacity={0.5} size={'32x32'}>
                <Icon.Edit />
            </Icon.Box>
        </div>
        <Text weight={'bold'}>Plan your perfect workout</Text>
        <Text weight={200} fontSize={12} opacity={0.85} marginTop={'10px'} marginBottom={'10px'} alignCenter={true}>
            Select exercises from the left hand pane to add them to your workout. Or use an existing workout as a
            template.
        </Text>
        {/* <Button padding={'8px 24px'}>Start from a template</Button> */}
        <Row align={'center'} cursor={'pointer'} marginTop={'10px'} onClick={toggleAdvancedSettings}>
            <Icon.Box size={'16x16'} opacity={0.5}>
                <Icon.Settings />
            </Icon.Box>
            <Text weight={100} opacity={0.5}>
                Advanced settings
            </Text>
        </Row>
    </Container>
);

const UnauthorizedWorkoutPlannerState = () => (
    <Container>
        <Icon.Box size={'42x42'}>
            <Icon.Logo />
        </Icon.Box>
        <OuterMargin margin={'16px 0'}>
            <div style={{ width: '200px' }}>
                <Text center={true} fontSize={12} weight={'bold'} opacity={0.9}>
                    Join Tona for FREE to use our Workout Planner
                </Text>
            </div>
        </OuterMargin>
        <HoverableLink to={'/'}>
            <Button padding={'8px 28px'}>
                <Text fontSize={12}>Join Us</Text>
            </Button>
        </HoverableLink>
    </Container>
);

const UnauthorizedExercisesState = () => (
    <Container>
        <OuterMargin margin={'8px 0'}>
            <div style={{ width: '200px' }}>
                <Text fontSize={12} weight={'bold'} center={true} opacity={0.6}>
                    Unlock our 3,000 plus exercises by joining Tona
                </Text>
            </div>
        </OuterMargin>
    </Container>
);

const PlannedWorkoutsEmptyState = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No planned workouts found</Text>
    </Container>
);

const NoWorkoutsFound = () => (
    <Container>
        <div style={{ margin: '0 0 10px 0' }}>
            <Icon.Box size={'32x32'}>
                <Icon.SadIcon />
            </Icon.Box>
        </div>
        <Text>No workouts found</Text>
    </Container>
);

BannerEmptyStatsLeaderboards = connect(mapStateToProps)(BannerEmptyStatsLeaderboards);
BannerEmptyStatsActivity = connect(mapStateToProps)(BannerEmptyStatsActivity);
CheckInClassEmptyState = connect(mapStateToProps)(CheckInClassEmptyState);

export {
    BannerEmptyStatsLeaderboards,
    BannerEmptyStatsActivity,
    ClassesEmptyState,
    MembersEmptyState,
    FollowersEmptyState,
    UsersEmptyState,
    BookersEmptyState,
    ClassNotSelectedState,
    CheckInClassEmptyState,
    NoWorkoutsFoundState,
    NoExercisesFoundState,
    WorkoutPlanEmptyState,
    UnauthorizedWorkoutPlannerState,
    UnauthorizedExercisesState,
    MembershipTypesEmptyState,
    PlannedWorkoutsEmptyState,
    NoWorkoutsFound,
};



// WEBPACK FOOTER //
// ./src/UI/Components/BannerEmptyStats/BannerEmptyStats.js